module.exports = __webpack_public_path__ + "img/5cirDir.ea639411.png";